import React from 'react';
import styles from '../../styles/components/answers/TextFieldList.module.css';
import { NumericTextField } from './NumericTextField';
import _ from 'lodash';
import { BaseNumericValidation } from '../../helpers/validationBuilder';
import UUID from '@ax2/common/model/UUID';

export interface NumericTextFieldRecord {
  id: UUID;
  label: string | null;
  value: number | null;
  error?: string;
}

export interface NumericTextFieldListData {
  options: NumericTextFieldRecord[];
  validation: BaseNumericValidation;
  isPercentageMode: boolean;
  onCompletion: (options: NumericTextFieldRecord[]) => void;
  key?: string;
}

export const NumericTextFieldList: React.FC<NumericTextFieldListData> = ({
  onCompletion,
  options,
  validation,
  isPercentageMode,
}) => {
  const [inputsData, setInputsData] = React.useState<NumericTextFieldRecord[]>(
    options
  );
  const [values, setValues] = React.useState<number[]>(
    options.map(o => o.value || 0)
  );
  return (
    <div>
      <div className={styles.listContainer}>
        {inputsData.map((d, index) => {
          return (
            <div key={index} className={styles.itemContainer}>
              <NumericTextField
                tabIndex={index + 1}
                value={d.value}
                error={d.error ? d.error : null}
                validation={validation}
                onCompletion={(v, e) => {
                  const newInputsData = [...inputsData];
                  newInputsData[index].value = v;
                  newInputsData[index].error = e ? e : undefined;
                  setInputsData(newInputsData);
                  onCompletion(newInputsData);
                  setValues(values => _.set(values, index, v || 0));
                }}
              />
              {d.label && <div className={styles.itemText}>{d.label}</div>}
              {d.error && <div className={styles.error}>{d.error}</div>}
            </div>
          );
        })}
        {isPercentageMode && (
          <div
            className={[
              styles.totalContainer,
              _.sum(values) > 100 ? styles.totalError : '',
            ].join(' ')}
          >
            <div className={styles.totalValue}>{_.sum(values)}%</div>
            <div>TOTAL</div>
          </div>
        )}
      </div>
    </div>
  );
};
